import { render, staticRenderFns } from "./Overlay.global.vue?vue&type=template&id=7410713c&scoped=true&lang=pug&"
import script from "./Overlay.global.vue?vue&type=script&lang=ts&"
export * from "./Overlay.global.vue?vue&type=script&lang=ts&"
import style0 from "./Overlay.global.vue?vue&type=style&index=0&id=7410713c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7410713c",
  null
  
)

export default component.exports